import { camelize } from '@app/utils';

const ALTELECTRO_DEFAULT_FOBS_CLOSED = {
  10: 'closedFOB220ARG',
  30: 'closedFOB110',
  43: 'closedFOB220',
  47: 'closedFOB110',
  173: 'closedFOB220'
};

export const getExpectedUnits = (product, productCountry, chains) => {
  const unitsFields = chains.map(chain => {
    return camelize(`${chain.prefix} Units ${productCountry.businessUnit}`);
  });

  return unitsFields.reduce((sum, field) => {
    return (sum += productCountry.metadata[field] || 0);
  }, 0);
};

// Returns the fob value
export const getCountryFOB = (product, productCountry, followType, fobs) => {
  const countryMetadata = productCountry && productCountry.metadata;
  const productMetadata = product && product.metadata;
  let fobType = productCountry.fobType;


  if (followType === 'VESTUARIO') {
    if (countryMetadata.fob) {
      return countryMetadata.fob || 0;
    } else {
      return productMetadata.finalFOB || 0;
    }
  }

  if (countryMetadata && fobType) {
    if (productCountry.fobType === 'customFOB') {
      return productCountry.customFOB || 0;
    } else {
      return productMetadata[fobType] || 0;
    }
    // console.log('productCountry has fobType', productCountry.fobType);
  }

  switch (followType) {
    case 'VESTUARIO':
      //console.log(countryMetadata)
      // Always return countr's final fob stored on ProductCountry.metadata.fob
      return countryMetadata.fob || 0;
    case 'FOOD':
    case 'HOGAR':
    case 'ELECTRO':
    case 'PETS':
      return countryMetadata['closedFOB'] || countryMetadata['openFOB'] || 0;
    case 'ALTELECTRO':
      fobType = productMetadata.fobType
      if(!fobType){
        fobType = ALTELECTRO_DEFAULT_FOBS_CLOSED[productCountry.CountryId]
      }
      return productMetadata[fobType] || 0;
    default:
      console.warn('followType not provided');
      return 0;
  }
};

// este en verdad es para 1 solo shipment
export const getShipmentFOB = (
  product,
  productCountry,
  shipment,
  followType,
  fobs
) => {
  const productMeta = product && product.metadata;
  const meta = productCountry && productCountry.metadata;
  //si shipment tiene fob type usar, fallback al valor de product country
  if (shipment && shipment.fobType === 'customFOB' && shipment.fob > 0) {
    return shipment.fob
  } else if (shipment && shipment.fobType) {
    if (shipment.fobType === 'customFOB' && followType !== 'HOGAR') {
      return shipment.fob || meta['customFOB'];
    } else if (shipment.fobType === 'finalFOB') {
      if (productCountry.fobType === 'customFOB') {
        return productCountry.customFOB;
      }
    }

    if(followType === 'ALTELECTRO'){
      let fobElectro = shipment.fobType || productCountry.fobType
      if(!fobElectro){
        fobElectro = ALTELECTRO_DEFAULT_FOBS_CLOSED[productCountry.CountryId]
      }
      return productMeta[fobElectro] || 0;
    }

    return productMeta[shipment.fobType] || 0;
  } else {
    // si shipment no tiene fob type usar countryFOB
    return getCountryFOB(product, productCountry, followType, fobs);
  }
};

export const getShipmentUnits = shipment => (shipment && shipment.units) || 0;

export const getShipmentsUnits = shipments => {
  return shipments.reduce(
    (sum, shipment) => sum + getShipmentUnits(shipment),
    0
  );
};

export const getShipmentTotalFob = (
  product,
  productCountry,
  followType,
  fobs,
  shipment
) =>
  getShipmentUnits(shipment) *
  parseFloat(
    getShipmentFOB(product, productCountry, shipment, followType, fobs)
  );

export const getShipmentsTotalFob = (
  product,
  productCountry,
  followType,
  fobs,
  shipments
) =>
  shipments.reduce(
    (sum, shipment) =>
    (sum += getShipmentTotalFob(
      product,
      productCountry,
      followType,
      fobs,
      shipment
    )),
    0
  );

export const getExpectedTotalFob = (
  product,
  productCountry,
  followType,
  fobs,
  chains
) =>
  getCountryFOB(product, productCountry, followType, fobs) *
  getExpectedUnits(product, productCountry, chains);

// gets data for 1 product/country/BusinessUnit
export const getCommercialData = (
  product,
  productCountry,
  followType,
  shipments,
  chains,
  fobs
) => ({
  expectedFob: getCountryFOB(product, productCountry, followType, fobs),
  expectedUnits: getExpectedUnits(product, productCountry, chains),
  expectedTotalFOB: getExpectedTotalFob(
    product,
    productCountry,
    followType,
    fobs,
    chains
  ),
  shipmentsTotalUnits: getShipmentsUnits(shipments),
  shipmentsTotalFOB: getShipmentsTotalFob(
    product,
    productCountry,
    followType,
    fobs,
    shipments
  )
});

export const getNewTotalUnitBusiness = (
  shipments: any,
  pcs: any,
  currentTotalUnits: any,
  unitsPerBox: any,
  metadataChains: any,
  currentProductCountry: any
) => {
  let newTotalUnits = 0;
  let currentTotalUnitChains = 0;
  let boxUnitsChainPercentage = 0;
  let newUnitsPerBoxChain = 0;
  let metadata = {};
  let data = [];
  // console.log('pcs', pcs)
  // console.log('shipments', shipments)
  pcs.map(pcsM => {
    if (shipments[pcsM.ShipmentId]) {
      newTotalUnits += pcsM.changes.units - shipments[pcsM.ShipmentId].units;
    } else if (!shipments[pcsM.ShipmentId]) {
      newTotalUnits += pcsM.changes.units;
    }
  });

  // console.log('Step 1', newTotalUnits);
  // console.log('currentProductCountry', currentProductCountry);
  // console.log('pcs', pcs);
  // console.log('currentTotalUnits', currentTotalUnits);
  // console.log('unitsPerBox', unitsPerBox);
  // console.log('metadataChains', metadataChains);
  // console.log('shipments', shipments);

  const totalUnitsPCS = newTotalUnits + currentTotalUnits;
  const totalChain = 1 / metadataChains.length;
  const newTotalUnitsPerBoxPCS = totalUnitsPCS / unitsPerBox;
  metadataChains.map(chain => {
    currentTotalUnitChains += currentProductCountry.metadata[chain]
      ? currentProductCountry.metadata[chain]
      : 0;
  });

  const totalBoxUnitChains = currentTotalUnitChains / unitsPerBox;
  if (currentTotalUnitChains > 0) {
    metadataChains.map(chain => {
      const currentBoxUnitsChain =
        currentProductCountry.metadata[chain] / unitsPerBox;
      boxUnitsChainPercentage =
        (currentBoxUnitsChain * 100) / totalBoxUnitChains / 100;

      newUnitsPerBoxChain = newTotalUnitsPerBoxPCS * boxUnitsChainPercentage;
      const newUnits = Math.round(newUnitsPerBoxChain) * unitsPerBox;
      data.push({ [chain]: newUnits });
      // metadata = { [chain]: Math.round(newUnitsPerBoxChain) };
    });
  } else {
    metadataChains.map(chain => {
      // newUnitsPerBoxChain =
      //   unitsPerBox * Math.round(totalChain * newUnitsPerBox);
      data.push({ [chain]: 0 });
      // metadata = { [chain]: newUnitsPerBoxChain };
    });
  }

  for (const unitBusiness of data) {
    metadata[Object.keys(unitBusiness)[0]] = Object.values(unitBusiness)[0];
  }
  // console.log('data',data)
  return data;
};
